// src/shared/services/ServiceInterface.js
class ServiceInterface {
    // Auth methods
    async getCurrentUser() { throw new Error('Not implemented'); }
    async login(credentials) { throw new Error('Not implemented'); }
    async logout() { throw new Error('Not implemented'); }
    async forgotPassword(email) { throw new Error('Not implemented'); }
    async confirmForgotPassword(email, code, newPassword) { throw new Error('Not implemented'); }

    // Activity methods
    async getActivities(nextPageToken, pageSize) { throw new Error('Not implemented'); }
    async createActivity(activityData) { throw new Error('Not implemented'); }
    async fetchActivity(activityId) { throw new Error('Not implemented'); }
    async updateActivity(activityId, activityData) { throw new Error('Not implemented'); }
    async deleteActivity(activityId) { throw new Error('Not implemented'); }

    // Competition methods
    async getAllCompetitions() { throw new Error('Not implemented'); }
    async fetchCompetition(competitionId) { throw new Error('Not implemented'); }
    async getCompetitionDetails(competitionId) { throw new Error('Not implemented'); }
    async createCompetition(competitionData) { throw new Error('Not implemented'); }
    async joinCompetition(currentUser, competitionId) { throw new Error('Not implemented'); }
    async getCompetitionStats(competitionId) { throw new Error('Not implemented'); }
    async getCompetitorHistory(competitionId, username) { throw new Error('Not implemented'); }
    async getCompetitionRules() { throw new Error('Not implemented'); }

    // Profile methods
    async fetchProfile(username) { throw new Error('Not implemented'); }
    async getProfile(username) { throw new Error('Not implemented'); }
    async updateProfile(username, profileData) { throw new Error('Not implemented'); }

    // Strava methods
    async getStravaStatus() { throw new Error('Not implemented'); }
    async connectStrava() { throw new Error('Not implemented'); }
    async handleStravaCallback(code, state) { throw new Error('Not implemented'); }
    async disconnectStrava() { throw new Error('Not implemented'); }

    // Dashboard methods
    async getFitHubData() { throw new Error('Not implemented'); }

    // Utility method
    async delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}

export default ServiceInterface;
